import { Badge } from '@/components/ui/badge';
import type { ResellerOrderStatus } from '@/hooks/useResellerOrders';

const map: Record<ResellerOrderStatus, { label: string; className: string }> = {
  pending: { label: 'Pending', className: 'bg-yellow-100 text-yellow-800 hover:bg-yellow-100' },
  approved: { label: 'Approved', className: 'bg-blue-100 text-blue-800 hover:bg-blue-100' },
  activated: { label: 'Activated', className: 'bg-green-100 text-green-800 hover:bg-green-100' },
  rejected: { label: 'Rejected', className: 'bg-red-100 text-red-800 hover:bg-red-100' },
  failed: { label: 'Failed', className: 'bg-red-100 text-red-800 hover:bg-red-100' },
  hold: { label: 'On Hold', className: 'bg-gray-100 text-gray-800 hover:bg-gray-100' },
};

export function OrderStatusBadge({ status }: { status: ResellerOrderStatus }) {
  const s = map[status] ?? { label: status, className: '' };
  return <Badge className={s.className} variant="secondary">{s.label}</Badge>;
}

export function formatMoney(amount: number, currency = 'USD') {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(Number(amount ?? 0));
}
